const { NODE_ENV } = process.env

export interface FeatureFlagsType {
  isAddAccountABTestingEnabled: boolean
  isAnnualIncomeNotificationEnabled: boolean
  isBalanceTransfersEnabled: boolean
  isCardAccessEnabled: boolean
  isCardStatusTrackerEnabled: boolean
  isCookieFooterLinkEnabled: boolean
  isCreateOrChangePinEnabled: boolean
  isCreditBalanceRefundEnabled: boolean
  isCreditViewDeepLinkEnabled: boolean
  isCustomCardArtDeepLinkEnabled: boolean
  isDigitalCollectionsExperienceEnabled: boolean
  isDisasterReliefBannerEnabled: boolean
  isDocumentCenterEnabled: boolean
  isDocumentCenterLettersNoticesEnabled: boolean
  isDYEnabled: boolean
  isDYScriptEnabled: boolean
  isEmailBounceNotificationEnabled: boolean
  isFraudDisputesEnabled: boolean
  isIncomeCaptureRuntimeEnabled: boolean
  isIRLEnabled: boolean
  isLargeAutopayIndicatorEnabled: boolean
  isLoanNickNameModalEnabled: boolean
  isMakeAPaymentRuntimeEnabled: boolean
  isMarketPlaceOfferEnabled: boolean
  isMigrateMeV2FlowEnabled: boolean
  isOfferOnAccountServicesEnabled: boolean
  isPaymentAmountRadioEnabled: boolean
  isPaymentSecurityEnabled: boolean
  isPostLoginActivationEnabled: boolean
  isPostOfficeReturnNotificationEnabled: boolean
  isPreApprovedOffersEnabled: boolean
  isProfileRuntimeEnabled: boolean
  isRCLogoutToMarketplaceEnabled: boolean
  isRemoveAuthUserEnabled: boolean
  isReplaceYourCardEnabled: boolean
  isReportLostOrStolenCardEnabled: boolean
  isRequestPastStatementEnabled: boolean
  isRequestPastStatementEnabledStatementsPage: boolean
  isRewardsRuntimeEnabled: boolean
  isSamsRewardsMfeEnabled: boolean
  isSearchEnabled: boolean
  isSettlementPlanEnabled: boolean
  isShowCookieSetting: boolean
  isSignInSecurityEnabled: boolean
  isStatementsRuntimeEnabled: boolean
  isTjxRewardsBorderEnabled: boolean
  isVantageRuntimeEnabled: boolean
  isVerizonRedemptionEnabled: boolean
  isWaivedInterestEnabled: boolean
  showActivityForSecuredInstallment: boolean
}
const prodFeatureFlags: FeatureFlagsType = {
  isAddAccountABTestingEnabled: false,
  isAnnualIncomeNotificationEnabled: false,
  isBalanceTransfersEnabled: true,
  isCardAccessEnabled: false,
  isCardStatusTrackerEnabled: false,
  isCookieFooterLinkEnabled: false,
  isCreateOrChangePinEnabled: true,
  isCreditBalanceRefundEnabled: true,
  isCreditViewDeepLinkEnabled: false,
  isCustomCardArtDeepLinkEnabled: false,
  isDigitalCollectionsExperienceEnabled: true,
  isDisasterReliefBannerEnabled: false,
  isDocumentCenterEnabled: true,
  isDocumentCenterLettersNoticesEnabled: false,
  isDYEnabled: false,
  isDYScriptEnabled: true,
  isEmailBounceNotificationEnabled: false,
  isFraudDisputesEnabled: false,
  isIncomeCaptureRuntimeEnabled: false,
  isIRLEnabled: false,
  isLargeAutopayIndicatorEnabled: false,
  isLoanNickNameModalEnabled: false,
  isMakeAPaymentRuntimeEnabled: true,
  isMarketPlaceOfferEnabled: false,
  isMigrateMeV2FlowEnabled: true,
  isOfferOnAccountServicesEnabled: false,
  isPaymentAmountRadioEnabled: false,
  isPaymentSecurityEnabled: false,
  isPostLoginActivationEnabled: false,
  isPostOfficeReturnNotificationEnabled: true,
  isPreApprovedOffersEnabled: false,
  isProfileRuntimeEnabled: true,
  isRCLogoutToMarketplaceEnabled: false,
  isRemoveAuthUserEnabled: false,
  isReplaceYourCardEnabled: false,
  isReportLostOrStolenCardEnabled: true,
  isRequestPastStatementEnabled: false,
  isRequestPastStatementEnabledStatementsPage: true,
  isRewardsRuntimeEnabled: true,
  isSamsRewardsMfeEnabled: false,
  isSearchEnabled: false,
  isSettlementPlanEnabled: false,
  isShowCookieSetting: false,
  isSignInSecurityEnabled: false,
  isStatementsRuntimeEnabled: true,
  isTjxRewardsBorderEnabled: true,
  isVantageRuntimeEnabled: false,
  isVerizonRedemptionEnabled: false,
  isWaivedInterestEnabled: false,
  showActivityForSecuredInstallment: false
}

const localFeatureFlags: FeatureFlagsType = {
  isAddAccountABTestingEnabled: false,
  isAnnualIncomeNotificationEnabled: true,
  isBalanceTransfersEnabled: true,
  isCardAccessEnabled: true,
  isCardStatusTrackerEnabled: true,
  isCookieFooterLinkEnabled: true,
  isCreateOrChangePinEnabled: true,
  isCreditBalanceRefundEnabled: true,
  isCreditViewDeepLinkEnabled: true,
  isCustomCardArtDeepLinkEnabled: true,
  isDigitalCollectionsExperienceEnabled: true,
  isDisasterReliefBannerEnabled: true,
  isDocumentCenterEnabled: true,
  isDocumentCenterLettersNoticesEnabled: true,
  isDYEnabled: true,
  isDYScriptEnabled: true,
  isEmailBounceNotificationEnabled: true,
  isFraudDisputesEnabled: true,
  isIncomeCaptureRuntimeEnabled: false,
  isIRLEnabled: true,
  isLargeAutopayIndicatorEnabled: true,
  isLoanNickNameModalEnabled: false,
  isMakeAPaymentRuntimeEnabled: true,
  isMarketPlaceOfferEnabled: false,
  isMigrateMeV2FlowEnabled: true,
  isOfferOnAccountServicesEnabled: false,
  isPaymentAmountRadioEnabled: true,
  isPaymentSecurityEnabled: true,
  isPostLoginActivationEnabled: true,
  isPostOfficeReturnNotificationEnabled: true,
  isPreApprovedOffersEnabled: false,
  isProfileRuntimeEnabled: true,
  isRCLogoutToMarketplaceEnabled: true,
  isRemoveAuthUserEnabled: true,
  isReplaceYourCardEnabled: true,
  isReportLostOrStolenCardEnabled: true,
  isRequestPastStatementEnabled: true,
  isRequestPastStatementEnabledStatementsPage: true,
  isRewardsRuntimeEnabled: true,
  isSamsRewardsMfeEnabled: true,
  isSearchEnabled: true,
  isSettlementPlanEnabled: true,
  isShowCookieSetting: true,
  isSignInSecurityEnabled: true,
  isStatementsRuntimeEnabled: true,
  isTjxRewardsBorderEnabled: true,
  isVantageRuntimeEnabled: false,
  isVerizonRedemptionEnabled: false,
  isWaivedInterestEnabled: true,
  showActivityForSecuredInstallment: true
}

const defaultFeatureFlags =
  NODE_ENV === 'production' ? prodFeatureFlags : localFeatureFlags

// To allow Cypress to inject featureFlags into window to mock the values

const runtimeFlags =
  typeof window !== 'undefined' &&
  (window as { featureFlags?: Partial<FeatureFlagsType> }).featureFlags
    ? (window as { featureFlags?: Partial<FeatureFlagsType> }).featureFlags
    : {}

const effectiveFeatureFlags: FeatureFlagsType =
  NODE_ENV !== 'production'
    ? { ...defaultFeatureFlags, ...runtimeFlags }
    : defaultFeatureFlags

export default effectiveFeatureFlags
